import { authComputed, authMethods } from "@/state/helpers";
import moment from "moment";
import store from "@/state/store";
export const base = {
  data() {
    return {
      isLoggedIn: Boolean(JSON.parse(localStorage.getItem("user"))),
      orderStatuses: [
        {
          name: "Initiated",
          value: 1,
        },
        {
          name: "Cancelled",
          value: 2,
        },
        {
          name: "Processing",
          value: 3,
        },
        {
          name: "Shipped",
          value: 4,
        },
        {
          name: "Delivered",
          value: 5,
        },
        {
          name: "Returned ",
          value: 6,
        },
        {
          name: "Sent To Warehouse",
          value: 7,
        },
        {
          name: "Picked and Packed ",
          value: 8,
        },
        {
          name: "Dispatched From Warehouse ",
          value: 9,
        },
        {
          name: "In Transit",
          value: 11,
        },
        {
          name: "Out For Delivery",
          value: 12,
        },
        {
          name: "First Delivery Attempt",
          value: 13,
        },
        {
          name: "Second Delivery Attempt",
          value: 14,
        },
        {
          name: "Third Delivery Attempt",
          value: 15,
        },
        {
          name: "On Hold",
          value: 16,
        },
        {
          name: "RTO",
          value: 17,
        },
        {
          name: "Unsuccessful Pickup ",
          value: 18,
        },
        {
          name: "Customer Rejected  ",
          value: 19,
        },
        {
          name: "WrongAddress  ",
          value: 20,
        },
        {
          name: "Unreachable",
          value: 21,
        },
        {
          name: "Address Changed ",
          value: 22,
        },
        {
          name: "Customer Rescheduled ",
          value: 23,
        },
        {
          name: "UnDelivered",
          value: 24,
        },
      ],
    };
  },
  computed: {
    ...authComputed,
    isRtl() {
      return ["ar"].includes(store.getters["auth/lang"]);
    },
  },
  methods: {
    ...authMethods,
    convertDate: function (timestampValue) {
      return moment.unix(timestampValue).format("DD/MM/YYYY");
    },

    logoutUser() {
      this.logout().then(() => {
        this.isLoggedIn = false;
        this.$router.push({ name: "landing" });
      });
    },
    isUserLoggedIn() {
      console.log(Boolean(JSON.parse(localStorage.getItem("user"))));
      return Boolean(JSON.parse(localStorage.getItem("user")));
    },
  },
};
